<template>
  <v-snackbar v-model="snackbarState.visible" location="top" :color="snackbarState.color" :timeout="snackbarState.timeout ?? 4000">
    <div style="white-space: pre-line">{{ snackbarState.message }}</div>
    <template v-slot:actions>
      <v-btn variant="text" icon="mdi-close" size="small" @click="snackbarState.visible = false" />
    </template>
  </v-snackbar>
</template>

<script>
import { reactive } from 'vue';

export const snackbarState = reactive({ message: '', color: 'error', visible: false, timeout: 4000 });

export function showSnackbar({ message, color = 'error', timeout = 4000 }) {
  snackbarState.message = message;
  snackbarState.color = color;
  snackbarState.timeout = timeout;
  snackbarState.visible = true;
}

export default {
  setup() {
    return { snackbarState };
  },
};
</script>
